import axios from "axios";

const API_URL = (process.env.REACT_APP_API_URL ?? "http://localhost:5094").replace(/\/$/, "");

export interface ContactRequest {
  name: string;
  email: string;
  subject?: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

// POST the contact form to the API, which emails it via SendGrid.
export const sendContactMessage = async (req: ContactRequest): Promise<ContactResponse> => {
  const response = await axios.post<ContactResponse>(`${API_URL}/api/contact`, req);
  return response.data;
};
